const errorMessages = {
  INCORRECT_PASSWORD: 'La contraseña es invalida.',
  TRADER_NOT_FOUND:
  'No pudimos validar la información ingresada. Verifica tus datos e inténtalo nuevamente.'
};

export default errorMessages;
